const numberToCurrency = (number) => '$' + (+number).toFixed(2);

export { numberToCurrency };